import { Routes } from '@angular/router';
import { authMatchGuard } from 'lib-auth';

export const rootRoutes: Routes = [
    {path: '', pathMatch: 'full', redirectTo: '/app/home'},
    {
        path: 'auth',
        loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
    },
    {
        path: 'app',
        loadChildren: () => import('./modules/app/app.module').then(m => m.AppModule),
        canMatch: [authMatchGuard]
    },
    {path: '**', redirectTo: '/app'}
];
